<script setup lang="ts">
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '~/constants/website'
</script>

<template>
  <UiSectionWrapper
    title="Kelola Pengiriman Lebih Mudah dari HP"
    sub-title="Aplikasi Mobile"
    description="Jadi pebisnis yang fleksibel dengan aplikasi KiriminAja. Cek ongkir, buat resi, kirim paket, dan cairkan COD semua dari smartphone Anda."
    hero-image="/images/aplikasi-mobile-banner-3.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
  >
    <template #action>
      <div class="flex items-center gap-4">
        <div class="flex flex-col gap-4">
          <NuxtLink
            :to="$utm.utmUrl(GOOGLE_PLAY_URL, undefined, true)"
            rel="noopener noreferrer"
          >
            <NuxtImg
              alt="google-play"
              src="/images/home-v4/playstore.webp"
              height="52px"
              class="max-w-full lg:h-[3.25rem] rounded-xl border border-transparent dark:border-outline-variant"
            />
          </NuxtLink>
          <NuxtLink :to="$utm.utmUrl(APP_STORE_URL)" rel="noopener noreferrer">
            <NuxtImg
              alt="apple-store"
              src="/images/home-v4/appstore2.webp"
              height="52px"
              class="max-w-full lg:h-[3.25rem] rounded-xl border border-transparent dark:border-outline-variant"
            />
          </NuxtLink>
        </div>
        <div class="w-px h-[60px] bg-outline"></div>
        <CtaQr />
      </div>
    </template>
  </UiSectionWrapper>
</template>
